import React from 'react';
import { createPortal } from 'react-dom';
import Modal from 'components/modal';
import { ReportMeaningsWrapper } from '@seedlang/hoc';
import { AppUI } from '@seedlang/state';
import ReportMeaningsForm from 'components/vocab/report_meanings_form';

class ReportMeaningsModal extends React.Component {
  render() {
    if (!this.props.open) return null;

    return createPortal(
      <Modal
        width={AppUI.layout.isMobile ? '92%' : '600px'}
        top='20px'
        height='min(680px, calc(100dvh - 40px))'
        contentShouldScroll
        onCloseModal={this.props.close}
        hideCloseIcon={false}
        title="Report a Problem"
        gradient
      >
        <ReportMeaningsForm
          {...this.props}
        />
      </Modal>,
      document.body
    );
  }
}

export default ReportMeaningsWrapper(ReportMeaningsModal);
